
import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import HowItWorks from "@/components/HowItWorks";
import Roadmap from "@/components/Roadmap";
import Footer from "@/components/Footer";
import QuestionsCTA from "@/components/QuestionsCTA";

const Index = () => {
  return (
    <div className="min-h-screen">
      {/* Skip link for keyboard users */}
      <a 
        href="#main-content" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-white focus:text-[#1211ca] focus:rounded-md focus:shadow-lg"
      >
        Skip to main content
      </a>
      
      <Navbar />
      <main id="main-content">
        <Hero />
        <Features />
        <Roadmap />
        <div id="how-it-works" tabIndex={-1}>
          <HowItWorks />
        </div>
        <QuestionsCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
